module.exports = {"name":"Stagione :season","name_med":":expansion Stagione :season","name_long":":expansion Stagione :season"};